var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BooleanInput, SaveButton, SimpleForm, useNotify, useRefresh } from "react-admin";
import { Box, InputLabel } from "@mui/material";
import { useMutation } from "@apollo/client";
import { EDIT_USER } from "@/queries/EditUser";
import { FormStyles } from "@/components/styles/FormStyles";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { styled } from "@mui/material/styles";
import { useTenantStore } from "@/providers/TenantContextProvider";
import IconTooltip from "@/components/IconTooltip";
import FormDialog from "@/components/FormDialog";
export var InputLabelStyle = styled(InputLabel, {
    shouldForwardProp: function (prop) { return prop !== "paddingTop"; },
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 135px;\n    ", "\n"], ["\n    width: 135px;\n    ", "\n"])), function (_a) {
    var _b = _a.paddingTop, paddingTop = _b === void 0 ? true : _b;
    return (paddingTop ? "padding-top: 15px;" : "padding-top: 0;");
});
export var InputContainerStyle = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    gap: 12px;\n    width: 100%;\n    align-items: baseline;\n    @media (max-width: ", "px) {\n        flex-direction: column;\n    }\n"], ["\n    display: flex;\n    gap: 12px;\n    width: 100%;\n    align-items: baseline;\n    @media (max-width: ", "px) {\n        flex-direction: column;\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.values.sm;
});
export var PasswordInputStyle = styled(FormStyles.PasswordInput)(function (_a) {
    var theme = _a.theme, error = _a.error;
    return {
        "flex": "1",
        "margin": "0 auto",
        "& .MuiFormHelperText-root.MuiFormHelperText-sizeSmall.MuiFormHelperText-contained": __assign({}, (error && {
            borderColor: theme.palette.error.main,
            color: theme.palette.error.main,
        })),
        "& .MuiOutlinedInput-root": {
            "& fieldset": __assign({}, (error && { borderColor: theme.palette.error.main })),
        },
        "& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall.MuiInputBase-adornedEnd": {
            marginBlockEnd: "0px",
        },
    };
});
var EditPassword = function (_a) {
    var open = _a.open, handleClose = _a.handleClose, id = _a.id, electionEventId = _a.electionEventId;
    var t = useTranslation().t;
    var tenantId = useTenantStore()[0];
    var refresh = useRefresh();
    var notify = useNotify();
    var _b = useState({ id: id }), user = _b[0], setUser = _b[1];
    var _c = useState(true), temporary = _c[0], setTemportay = _c[1];
    var edit_user = useMutation(EDIT_USER)[0];
    var _d = useState(""), errorText = _d[0], setErrorText = _d[1];
    var equalToPassword = function (allValues) {
        if (!allValues.password || allValues.password.length == 0) {
            return;
        }
        if (allValues.confirm_password !== allValues.password) {
            setErrorText(t("usersAndRolesScreen.users.fields.passwordMismatch"));
        }
        if (errorText && allValues.confirm_password === allValues.password) {
            setErrorText("");
        }
    };
    var handleChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, name, value, updatedUser;
        var _b;
        return __generator(this, function (_c) {
            _a = e.target, name = _a.name, value = _a.value;
            updatedUser = __assign(__assign({}, user), (_b = {}, _b[name] = value, _b));
            //only run on password update
            if (name === "confirm_password" || name === "password") {
                equalToPassword(updatedUser);
            }
            setUser(updatedUser);
            return [2 /*return*/];
        });
    }); };
    var validatePassword = function (value) {
        /*TODO: we should validate only to the extent that these policies are
        in place in keycloak
        if (!value || value.length == 0) {
            return
        }
     
        const hasEnoughChars = value.length < 8
        const hasUpperCase = /[A-Z]/.test(value)
        const hasLowerCase = /[a-z]/.test(value)
        const hasDigit = /\d/.test(value)
        const hasSpecialChar = /[^a-zA-Z\d]/.test(value)
     
        if (hasEnoughChars) {
            return t("usersAndRolesScreen.users.fields.passwordLengthValidate")
        }
     
        if (!hasUpperCase) {
            return t("usersAndRolesScreen.users.fields.passwordUppercaseValidate")
        }
     
        if (!hasLowerCase) {
            return t("usersAndRolesScreen.users.fields.passwordLowercaseValidate")
        }
     
        if (!hasDigit) {
            return t("usersAndRolesScreen.users.fields.passwordDigitValidate")
        }
     
        if (!hasSpecialChar) {
            return t("usersAndRolesScreen.users.fields.passwordSpecialCharValidate")
        }*/
    };
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, edit_user({
                            variables: {
                                body: {
                                    user_id: user === null || user === void 0 ? void 0 : user.id,
                                    tenant_id: tenantId,
                                    election_event_id: electionEventId,
                                    password: (user === null || user === void 0 ? void 0 : user.password) && (user === null || user === void 0 ? void 0 : user.password.length) > 0 ? user.password : undefined,
                                    temporary: temporary,
                                },
                            },
                        })];
                case 1:
                    _a.sent();
                    notify(t("usersAndRolesScreen.voters.errors.editSuccess"), { type: "success" });
                    refresh();
                    handleClose === null || handleClose === void 0 ? void 0 : handleClose();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    notify(t("usersAndRolesScreen.voters.errors.editError"), { type: "error" });
                    handleClose === null || handleClose === void 0 ? void 0 : handleClose();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(FormDialog, __assign({ open: open, onClose: handleClose, title: t("usersAndRolesScreen.editPassword.label") }, { children: _jsx(_Fragment, { children: _jsx(SimpleForm, __assign({ toolbar: _jsx(SaveButton, { fullWidth: true, alwaysEnable: !errorText }), record: user, onSubmit: onSubmit, sanitizeEmptyValues: true, sx: { padding: 0 } }, { children: _jsxs(_Fragment, { children: [_jsxs(InputContainerStyle, { children: [_jsxs(InputLabelStyle, { children: [t("usersAndRolesScreen.users.fields.password"), ":"] }), _jsx(PasswordInputStyle, { label: false, source: "password", onChange: handleChange, error: !!errorText })] }), _jsxs(InputContainerStyle, { children: [_jsxs(InputLabelStyle, { children: [t("usersAndRolesScreen.users.fields.repeatPassword"), ":"] }), _jsx(PasswordInputStyle, { label: false, source: "confirm_password", helperText: errorText, error: !!errorText, onChange: handleChange })] }), _jsxs(InputContainerStyle, __assign({ sx: { flexDirection: "row !important" } }, { children: [_jsx(InputLabelStyle, __assign({ paddingTop: false }, { children: _jsxs(Box, __assign({ sx: { display: "flex", gap: "8px" } }, { children: [t("usersAndRolesScreen.editPassword.temporatyLabel"), _jsx(IconTooltip, { icon: faInfoCircle, info: t("usersAndRolesScreen.editPassword.temporatyInfo") })] })) })), _jsx(BooleanInput, { source: "", label: false, onChange: function (e) { return setTemportay(!temporary); }, checked: temporary })] }))] }) })) }) })));
};
export default EditPassword;
var templateObject_1, templateObject_2;
